import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface ControlledFiltersState {
  isControlled: boolean;
}

const initialState: ControlledFiltersState = {
  isControlled: false
};

const controlledFiltersSlice = createSlice({
  name: 'controlledFilters',
  initialState,
  reducers: {
    setControlledFiltersMode: ( state, action: PayloadAction<boolean> ) => {
      state.isControlled = action.payload;
    }
  }
});

export const { setControlledFiltersMode } = controlledFiltersSlice.actions;

export const selectIsFiltersControlled = ( state: RootState ) =>
  state.spreadsheet.controlledFilters.isControlled;

export default controlledFiltersSlice.reducer;
